import { SubcategoryProcessingRule } from '../interfaces';
import { Subcategory } from '@core/models';

export const subcategoryHasProductsRule: SubcategoryProcessingRule = context => ({
	...context,
	subcategories: context.subcategories.filter(hasSubcategoryProducts),
});

export function hasSubcategoryProducts(subcategory: Subcategory): boolean {
	return subcategory.count_menu_items > 0;
}

export function hasSubcategoryValids(subcategoryList: Subcategory[], subcategoryId: string): Subcategory | null {
	return subcategoryList.find((subcategory) =>( subcategory.idSubcategoria === subcategoryId) && hasSubcategoryProducts(subcategory)) ?? null;
}